<template>
  <div class="onlineReserve-rule">
    <van-row type="flex" justify="center" class="row-title">
      <van-col span="20" class="col-title">
        <p>预约规则</p>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-common">
      <van-col span="23" class="col-common">
        <p>您即将进入不动产预约服务，该服务目前仅向在本微信公众号实名认证的不动产登记权利人提供。您已被告知必须对所提供的相关信息的合法性、真实性、有效性负责，我们同时承诺您所提供的信息将仅用于预约窗口，不会被故意篡改、泄露或挪作他用。</p>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-major">
      <van-col span="23" class="col-major">
        <p>现将不动产登记预约规则告知如下：</p>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-common">
      <van-col span="23" class="col-common">
        <p>1、为规范不动产登记网上预约工作，进一步优化中心业务受理秩序，有效减少群众等待时间，提升窗口的服务效能和服务水平，结合中心工作实际，特制定本制度；</p>
        <p>2、网上预约是指申请人通过网站、微信等预约的方式提前与中心预约申请办理不动产登记服务的具体时间，中心在约定时间内，为申请人提供相应的不动产登记服务；</p>
        <p>3、网上预约服务的具体时间段为工作日上午<span>9:00～16:40</span>，以每30分钟为时间间隔开展预约；目前每<span>30</span>分钟限制预约1个，每天开放预约暂定16个；</p>
        <p>4、一个网上预约号原则上只能办理一件不动产登记业务，需要办理抵押注销才能过户的，视同一件业务。目前只接收个人或者单位预约，暂不接收批量预约；</p>
        <p>5、网上预约服务采取实名制，预约申请人必须是办理不动产登记业务的申请人或代理人，每个手机号每天限预约一次；</p>
        <p>6、预约申请人须认真阅读网上预约的操作说明，准备好预约办理业务的要件材料，不动产登记专栏办事指南或者拨打中心电话（<span>{{ dJXT_LXDH }}</span>）咨询；</p>
        <p>7、预约申请人超过预约办理起始时间未到场，视为预约申请人主动放弃预约服务，预约号自动失效。须现场重新取号并排队办理相关业务；</p>
        <p><span>8、本制度由{{ dJXT_QXMC }}不动产登记服务中心负责解释，自发布之日起施行；</span></p>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-rule">
      <van-col span="24" class="col-rule">
        <van-field name="checkboxGroup">
          <template #input>
            <van-checkbox-group v-model="checkboxGroup" direction="horizontal">
              <van-checkbox name="1">
                <span>我已阅读并遵守预约规则</span>
              </van-checkbox>
            </van-checkbox-group>
          </template>
        </van-field>
      </van-col>
    </van-row>
    <van-row type="flex" justify="center" class="row-button">
      <van-col span="22" class="col-button">
        <van-button round type="info" @click="confirmRead">
          我要预约
        </van-button>
      </van-col>
    </van-row>
  </div>
</template>

<script type="text/javascript">

import { getSystemConfig } from '@/api/systemConfig.js'
import { Notify } from 'vant'
export default {
  components: {},
  data() {
    return {
      dJXT_QXMC: '',
      dJXT_LXDH: '',
      checkbox: false,
      checkboxGroup: []
    }
  },
  mounted() {
    this.loadSystemConfig()
  },
  created() {

  },
  methods: {
    loadSystemConfig() {
      getSystemConfig({ key: 'DJXT_QXMC' }).then(response => {
        this.dJXT_QXMC = response.data.value
      })
      getSystemConfig({ key: 'DJXT_LXDH' }).then(response => {
        this.dJXT_LXDH = response.data.value
      })
    },
    confirmRead() {
      const isConfirm = this.checkboxGroup.length
      if (isConfirm === 0) {
        Notify({
          type: 'danger',
          message: '请勾选我已阅读并遵守预约规则！',
          duration: 2000
        })
      } else {
        setTimeout(() => {
          // 跳转在线预约页面
          this.$router.push({
            path: '/onlinereserve/add'
          })
        }, 100)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.onlineReserve-rule{
  .col-title{
    font-size: 1.8em;
    color: #1279BC;
    font-weight: bold;
    p{
      margin: 30px 0 15px;
      text-align: center;
    }
  }
  .col-common{
    p{
      margin: 0;
      color: #888;
      line-height: 30px;
      span{
        color: red;
      }
    }
  }
  .col-major{
    p{
      color: #000;
      font-weight: bold;
      margin: 20px 0 5px;
    }
  }
  .col-rule{
    .van-cell{
      padding: 20px 10px;
      span{
        font-size: 1.2em;
        color: #777;
        font-weight: 600;
      }
    }
  }
  .col-button{
    padding: 10px 0 30px;
    button{
      width: 100%;
    }
  }
}
</style>
